import { IonPage } from '@ionic/react'
import React from 'react'
import PCRHeader from '../../../../../components/pcrHeader/PCRHeader.component'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router'
import { setSelectedOption } from '../../../store/initialAssessment.actions'
import { TabConstants } from '../../../../../components/tabs/Tabs.constants'
import { InitialAssessmentConstants } from '../../../store/initialAssessment.constants'
import HeaderNav from '../../../../../components/headerNav/HeaderNav.component'
import PediatricCommaScoreContent from '../content/PediatricTraumaScore.content'

const PediatricCommaScore: React.FC = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const history = useHistory()

  const onBackClick = () => {
    dispatch(setSelectedOption(InitialAssessmentConstants.NEURO))
    history.push(TabConstants.INITIAL_ASSESSMENT)
  }
  return (
    <IonPage id='PediatricCommaScore'>
      <PCRHeader />
      <HeaderNav
        prevOnClick={onBackClick}
        prevLabel={t('common.buttons.Back')}
        title={t('neuro.pediatricTraumaScore.pediatricTraumaScore')}
        isBackButton={true}
      />
      <PediatricCommaScoreContent />
    </IonPage>
  )
}

export default PediatricCommaScore
